import { useEffect, useState } from "react";
import { BTN } from "./lib";

export function Stat({ label, value, hint = "", tone = "" }) {
  return (
    <div className="rounded-xl border border-sky-800/40 bg-[#041228]/80 p-3">
      <div className="text-[10px] uppercase tracking-wider text-sky-400/60">{label}</div>
      <div className={`mt-0.5 text-xl font-bold ${tone || "text-white"}`}>{value}</div>
      {hint && <div className="text-[10px] text-sky-400/50">{hint}</div>}
    </div>
  );
}

export function Stats({ children }) {
  return <div className="grid grid-cols-2 gap-2.5 sm:grid-cols-3 lg:grid-cols-6">{children}</div>;
}

export function Chip({ children, cls = "border-sky-800/50 bg-sky-950/80 text-sky-200" }) {
  return <span className={`rounded border px-1.5 py-0.5 text-[10px] ${cls}`}>{children}</span>;
}

export function Filters({ items, value, onChange, children }) {
  return (
    <div className="flex flex-wrap items-center gap-2">
      {items.map(([key, label]) => (
        <button
          key={key || "all"}
          onClick={() => onChange(key)}
          className={`rounded-lg border px-2.5 py-1 text-[11px] transition-colors ${
            value === key
              ? "border-sky-400/60 bg-sky-900/70 text-white"
              : "border-sky-800/50 bg-[#041228] text-sky-300 hover:bg-sky-900/40"
          }`}
        >
          {label}
        </button>
      ))}
      {children}
    </div>
  );
}

/** Qidiruv har harfda emas — yozib bo'lgach (`onSearch` 300 ms keyin). */
export function Search({ placeholder, onSearch }) {
  const [input, setInput] = useState("");
  useEffect(() => {
    const t = setTimeout(() => onSearch(input.trim()), 300);
    return () => clearTimeout(t);
  }, [input, onSearch]);
  return (
    <input
      value={input}
      onChange={(e) => setInput(e.target.value)}
      placeholder={placeholder}
      className="ml-auto w-56 rounded-lg border border-sky-800/50 bg-[#041228] px-2.5 py-1 text-[11px] text-white placeholder:text-sky-700 focus:border-sky-500 focus:outline-none"
    />
  );
}

export function List({ loading, items, empty, children }) {
  if (loading) return <div className="py-10 text-center text-xs text-sky-400/60">yuklanmoqda...</div>;
  if (!items.length)
    return (
      <div className="rounded-xl border border-sky-800/40 bg-[#041228]/60 py-10 text-center text-xs text-sky-400/60">
        {empty || "Bu filtr bo'yicha yozuv yo'q"}
      </div>
    );
  return children;
}

export function Pager({ page, setPage, full }) {
  return (
    <div className="flex items-center justify-between pt-2">
      <button onClick={() => setPage((p) => Math.max(0, p - 1))} disabled={page === 0} className={BTN}>
        ← Oldingi
      </button>
      <span className="text-[11px] text-sky-400/60">{page + 1}-sahifa</span>
      <button onClick={() => setPage((p) => p + 1)} disabled={!full} className={BTN}>
        Keyingi →
      </button>
    </div>
  );
}

export function Alert({ children }) {
  if (!children) return null;
  return (
    <div role="alert" className="rounded-xl border border-rose-800/50 bg-rose-950/40 p-3 text-xs text-rose-200">
      {children}
    </div>
  );
}

export function Panel({ title, children }) {
  return (
    <div className="rounded-lg border border-sky-900/50 bg-[#041228]/80 p-2.5 text-[11px] leading-relaxed text-slate-300">
      <div className="mb-1.5 text-[10px] uppercase tracking-wider text-sky-400/60">{title}</div>
      {children}
    </div>
  );
}
